import { SVGProps } from 'react';

export interface IconCommunityGradientProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const IconCommunityGradient = (props: IconCommunityGradientProps) => {
	const { className, ...remainingProps } = props;

	return (
		<svg
			className={className}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label="Community Icon"
			{...remainingProps}
		>
			<path
				d="M10.5 22.5C8.01822 22.5 5.99997 20.313 5.99997 17.625C5.99997 14.937 8.01822 12.75 10.5 12.75C12.9817 12.75 15 14.937 15 17.625C15 20.313 12.9817 22.5 10.5 22.5Z"
				fill="url(#icon_community_gradient_1)"
			/>
			<path
				d="M16.8067 32.25H4.18872C3.19272 32.25 2.12247 31.4047 2.26122 30.141C2.64072 26.6407 6.18297 24 10.5 24C14.8132 24 18.3547 26.6377 18.7387 30.1357C18.876 31.41 17.805 32.25 16.8067 32.25Z"
				fill="url(#icon_community_gradient_2)"
			/>
			<path
				d="M43.8067 32.25H31.1887C30.1927 32.25 29.1225 31.4047 29.2612 30.141C29.6407 26.6407 33.183 24 37.5 24C41.8132 24 45.3547 26.6377 45.7387 30.1357C45.876 31.41 44.805 32.25 43.8067 32.25Z"
				fill="url(#icon_community_gradient_3)"
			/>
			<path
				d="M37.5 22.5C35.0182 22.5 33 20.313 33 17.625C33 14.937 35.0182 12.75 37.5 12.75C39.9817 12.75 42 14.937 42 17.625C42 20.313 39.9817 22.5 37.5 22.5Z"
				fill="url(#icon_community_gradient_4)"
			/>
			<path
				d="M32.5732 39.75C28.4745 39.75 20.2762 39.75 16.1775 39.75C13.803 39.75 11.9632 37.2712 13.0762 34.9597C14.9362 31.0972 19.3717 28.602 24.375 28.602C29.3782 28.602 33.8137 31.0972 35.6737 34.9597C36.8407 37.383 34.8277 39.75 32.5732 39.75ZM24.375 31.602C20.5762 31.602 17.1052 33.4673 15.7785 36.261C15.6585 36.5145 15.9412 36.75 16.1767 36.75C20.2755 36.75 28.4737 36.75 32.5725 36.75C32.8065 36.75 33.0915 36.5152 32.9707 36.2617C31.6447 33.4672 28.1737 31.602 24.375 31.602Z"
				fill="url(#icon_community_gradient_5)"
			/>
			<path
				d="M24 27C20.6917 27 18 24.1402 18 20.625C18 17.1098 20.6917 14.25 24 14.25C27.3082 14.25 30 17.1098 30 20.625C30 24.1402 27.3082 27 24 27ZM24 17.25C22.3455 17.25 21 18.7642 21 20.625C21 22.4858 22.3455 24 24 24C25.6545 24 27 22.4858 27 20.625C27 18.7642 25.6545 17.25 24 17.25Z"
				fill="url(#icon_community_gradient_6)"
			/>
			<defs>
				<linearGradient
					id="icon_community_gradient_1"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
				<linearGradient
					id="icon_community_gradient_2"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
				<linearGradient
					id="icon_community_gradient_3"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
				<linearGradient
					id="icon_community_gradient_4"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
				<linearGradient
					id="icon_community_gradient_5"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
				<linearGradient
					id="icon_community_gradient_6"
					x1="15.4567"
					y1="-13.125"
					x2="64.4847"
					y2="26.0872"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default IconCommunityGradient;
